<template lang="">
    <div>
        aqui lista de configuraciones    
    </div>
</template>
<script>
export default {
    
}
</script>